// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__8NyI-","brand":"style_brand__gCyix","cardNumber":"style_cardNumber__1q5D-","expiry":"style_expiry__2UM3g","alert":"style_alert__1KlkO"};